import useTranslation from '@/hooks/useTranslation';
import { ToastMessageProps } from '@/types';

function ToastMessage({ title, description, isAuthScreen }: ToastMessageProps) {
  const { lang } = useTranslation();
  const translatedTitle = isAuthScreen ? title : lang.get(`msg.${title}`);
  const translatedDescription = isAuthScreen ? description : lang.get(`msg.${description}`);
  return (
    <>
      <strong className="text-sm">{translatedTitle}</strong>
      <div className="text-sm mb-1.5">{translatedDescription}</div>
    </>
  );
}

export default ToastMessage;
